const AUTH_PRESERVED_QUERY_KEYS = [
  "ref",
  "affiliateCode",
  "code",
  "returnTo",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

export function sanitizeInternalReturnTo(
  value: string | null | undefined,
  fallback = "/",
): string {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return fallback;
  }

  try {
    const parsed = new URL(value, "https://app.ilovemacumba.local");
    return parsed.origin === "https://app.ilovemacumba.local"
      ? `${parsed.pathname}${parsed.search}${parsed.hash}`
      : fallback;
  } catch {
    return fallback;
  }
}

export function buildAuthPreservedSearch(
  searchParams: URLSearchParams,
): string {
  const next = new URLSearchParams();

  for (const key of AUTH_PRESERVED_QUERY_KEYS) {
    const value = searchParams.get(key);
    if (value) {
      next.set(key, value);
    }
  }

  const serialized = next.toString();
  return serialized ? `?${serialized}` : "";
}

export function resolveSignupAttributionCode(
  searchParams: URLSearchParams,
  fallbackCode?: string | null,
): string | undefined {
  const resolved =
    searchParams.get("ref")?.trim() ||
    searchParams.get("affiliateCode")?.trim() ||
    searchParams.get("code")?.trim() ||
    fallbackCode?.trim();

  return resolved || undefined;
}

export function parseCodeFromPath(path?: string): string | undefined {
  if (!path || !path.includes("?")) {
    return undefined;
  }

  const query = path.split("?")[1] ?? "";
  const params = new URLSearchParams(query);
  return resolveSignupAttributionCode(params);
}
